<script>
  import { Doc, Collection } from '../modules/sveltefire'

  import { role$ } from '../store'

  import LoadingIndicator from '../components/LoadingIndicator.svelte'

  import FirebaseInit from '../components/firestore/FirebaseInit.svelte'
  import DriveReportSelector from '../components/firestore/DriveReportSelector.svelte'
  import DriveReportCreator from '../components/firestore/DriveReportCreator.svelte'
  import DriveReportEditor from '../components/firestore/DriveReportEditor.svelte'
  import RouteLogsEditor from '../components/firestore/RouteLogsEditor.svelte'

  let date // 日付
  let reporterName // 報告者名
  let reportId // 運転日報のドキュメントID
</script>

<FirebaseInit>
  <h1>
    運転日報 編集
    {#if $role$}
      <i class="fas fa-lock" />
    {/if}
  </h1>

  <!-- 運転日報の選択 -->
  <DriveReportSelector bind:date bind:reporterName bind:reportId />

  <hr />

  {#if reportId}
    <Doc
      path={`driveReports/${reportId}`}
      let:data={report}
      let:ref={reportRef}
    >
      <!-- ドキュメント 読込中 -->
      <span slot="loading">
        <LoadingIndicator>読込中...</LoadingIndicator>
      </span>

      <!-- ドキュメントが見つからない場合、新規作成を促す -->
      <span slot="fallback">
        <!-- 運転日報 作成ボタン -->
        <DriveReportCreator {reportRef} {date} {reporterName} />
      </span>

      <!-- ドキュメントが存在する場合 -->
      {console.log(report) || ''}
      <DriveReportEditor {report} {reportRef} />

      <hr />

      <!-- 走行記録 -->
      <Collection
        path={reportRef.collection('routeLogs')}
        query={(ref) => ref.orderBy('order')}
        let:data={logs}
        let:ref={logsRef}
      >
        <!-- コレクション 読込中 -->
        <span slot="loading">
          <LoadingIndicator>読込中...</LoadingIndicator>
        </span>

        <!-- 走行記録エディタ -->
        {console.log(logs) || ''}
        <RouteLogsEditor {logs} {logsRef} {date} {reporterName} />

        <!-- エラー表示 -->
        <span slot="fallback">エラーで表示できません...</span>
      </Collection>
    </Doc>
  {/if}
</FirebaseInit>
